import { useAtom } from '@reatom/npm-react'
import * as DateF from 'date-fns'
import { match } from 'ts-pattern'

import { environmentAtom } from '@root/shared'
import { dateBySecondAtom } from '@root/shared/lib'

import type { PathfinderQuoteSubscriptionModel } from '@root/features/quote/atoms/reatom-quote-subscription'
import type { ClassNameProps } from '@root/shared/react'

type DevQuoteStatus = 'none' | 'waiting' | 'ready' | 'timeout'

type Args = {
  quoteModel: PathfinderQuoteSubscriptionModel | undefined
} & ClassNameProps

const QUOTE_WAIT_TIMEOUT = 5000

export const useQuoteDevStatus = ({ quoteModel }: Args) => {
  const [quoteDevStatus] = useAtom(
    (ctx) => {
      const { isDev } = ctx.get(environmentAtom)
      if (!isDev) {
        return undefined
      }
      if (!quoteModel) {
        return undefined
      }

      const quoteState = ctx.spy(quoteModel)

      return match(quoteState)
        .returnType<DevQuoteStatus | undefined>()
        .with({ type: 'Error' }, () => 'none')
        .with({ type: 'Loading' }, () => 'waiting')
        .with({ type: 'Success' }, ({ value }) => {
          const date = ctx.spy(dateBySecondAtom)
          const timestamp = value.timestamp

          if (
            DateF.differenceInMilliseconds(date, timestamp) > QUOTE_WAIT_TIMEOUT
          ) {
            return 'timeout'
          }

          return 'ready'
        })
        .with({ type: 'NotInitiated' }, () => undefined)
        .exhaustive()
    },
    [quoteModel],
  )

  return { quoteDevStatus }
}
